import {
  Alert,
  AlertTitle,
  Box,
  Chip,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import './WebhooksRoute.css';

function WebhooksRoute() {
  return (
    <div className="WebhooksRoute">
      <Alert
        severity="info"
        sx={{ marginBottom: 2 }}
        action={
          <Chip
            label="Coming soon"
            color="warning"
            size="small"
            sx={{ alignSelf: 'center' }}
          />
        }
      >
        <AlertTitle>Webhooks</AlertTitle>
        <Typography variant="body2">
          Subscribe to events from your account and receive HTTP callbacks
          whenever invoices, payments or customers change. This page will let
          you register endpoints, pick the events you care about and inspect
          delivery history.
        </Typography>
      </Alert>

      <Paper variant="outlined" sx={{ p: 4 }}>
        <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center' }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: 'action.hover',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <HourglassEmptyOutlinedIcon
              sx={{ fontSize: 32, color: 'text.secondary' }}
            />
          </Box>
          <Typography variant="h6">Under construction</Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 480 }}
          >
            Webhook delivery is not available yet. We'll announce it here once
            event subscriptions and signed payloads are ready.
          </Typography>
        </Stack>
      </Paper>
    </div>
  );
}

export default WebhooksRoute;
